import { render, staticRenderFns } from "./DepositoryChildFoldersView.vue?vue&type=template&id=7b184f94&scoped=true&lang=pug&"
import script from "./DepositoryChildFoldersView.vue?vue&type=script&lang=ts&"
export * from "./DepositoryChildFoldersView.vue?vue&type=script&lang=ts&"
import style0 from "./DepositoryChildFoldersView.vue?vue&type=style&index=0&id=7b184f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b184f94",
  null
  
)

export default component.exports